@if (itemCount(); as itemCount) {
  <a i18nRouterLink="/cart" [matBadge]="itemCount" matBadgeSize="small">
    <svg-icon
      class="fill-black hover:fill-primary"
      src="/assets/icons/shopping-cart.svg"
    />
    <span class="sr-only" i18n>Shopping Cart</span>
  </a>
}
